import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  children: [],
  selectedChild: null,
  loading: false,
  error: null,
};

const childrenSlice = createSlice({
  name: 'children',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setChildren: (state, action) => {
      state.children = action.payload;
      state.loading = false;
      state.error = null;
    },
    addChild: (state, action) => {
      const child = action.payload;
      const existingIndex = state.children.findIndex(c => c.id === child.id);
      
      if (existingIndex === -1) {
        state.children.push(child);
      } else {
        state.children[existingIndex] = child;
      }
    },
    updateChild: (state, action) => {
      const { id, changes } = action.payload;
      const childIndex = state.children.findIndex(c => c.id === id);
      
      if (childIndex !== -1) {
        state.children[childIndex] = { ...state.children[childIndex], ...changes };
        
        // Update selected child if it's the one being updated
        if (state.selectedChild && state.selectedChild.id === id) {
          state.selectedChild = { ...state.selectedChild, ...changes };
        }
      }
    },
    removeChild: (state, action) => {
      const childId = action.payload;
      state.children = state.children.filter(child => child.id !== childId);
      
      // Clear selected child if it was removed
      if (state.selectedChild && state.selectedChild.id === childId) {
        state.selectedChild = null;
      }
    },
    setSelectedChild: (state, action) => {
      const childId = action.payload;
      state.selectedChild = state.children.find(child => child.id === childId) || null;
    },
    clearSelectedChild: (state) => {
      state.selectedChild = null;
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  setChildren,
  addChild,
  updateChild,
  removeChild,
  setSelectedChild,
  clearSelectedChild,
} = childrenSlice.actions;

export default childrenSlice.reducer;